import { HisValueGroup } from '../../model/his-value-group';
import { ComponentFixtureAutoDetect, TestBed } from '@angular/core/testing';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HisDynamicFieldConfig, HisDynamicFieldType } from '../../model/formfield';
import { HisCoreModule } from '../../../his-core.module';
import { UntypedFormGroup } from '@angular/forms';
import { HisUiService } from '../../../core/service/base/his-ui.service';

export class HisDynamicFormTestBase {
    static getTestbedConfiguration(
        config: HisDynamicFieldConfig,
        additionalProviders?: any[],
        additionalImports?: any[]
    ): () => void {
        const result = () => {
            let baseConfig: HisDynamicFieldConfig = {
                name: 'Form',
                controlType: HisDynamicFieldType.Form,
                label: 'Form',
                children: [ config ]
            };
            let providers = [
                { provide: ComponentFixtureAutoDetect, useValue: true },
                {
                    provide: HisUiService,
                    useValue: {
                        translate( key: string, ...params: ( string | number | Date )[] ): string {
                            return key + '_translated{' + params.join( ', ' ) + '}';
                        },
                        translateOrEmpty( key: string, ...params: ( string | number | Date )[] ): string {
                            return key + '_translated{' + params.join( ', ' ) + '}';
                        }
                    }
                },
                {
                    provide: 'injectedData',
                    useValue: {
                        formGroup: new UntypedFormGroup( {} ),
                        options: config,
                        valueGroup: new HisValueGroup( baseConfig.children.length )
                    }
                },
            ];
            let imports = [
                // Angular
                BrowserAnimationsModule,

                // HIS
                HisCoreModule
            ];
            if ( additionalProviders ) {
                providers = providers.concat( additionalProviders );
            }
            if ( additionalImports ) {
                imports = imports.concat( additionalImports );
            }
            TestBed.configureTestingModule( {
                imports,
                declarations: [
                ],
                providers,
                teardown: {
                    destroyAfterEach: false
                }
            } ).compileComponents();
        };
        return result;
    }
}
